export function extractDefaultPremioExtracao(lstPremioExtracao){

    const lst = lstPremioExtracao.filter(pex => pex.tnyExtracao == 0) || []
    if(lst && lst.length > 0){
           return lst[0] 
    }

    return null
}



export function getExtracoes(arrExtracoes){

    var moment = require('moment');
    var datas = [];
    var dataComparacao;
    var now = moment();
    
    for (var i=0; i < arrExtracoes.length; i++) {

        if(arrExtracoes[i].bitBolao == 0 && arrExtracoes[i].bitConcurso == 0){

            dataComparacao = moment( now.format('DD-MM-YYYY ' + arrExtracoes[i].chrHorarioBloqueio), 'DD-MM-YYYY hh:mm');

            if(now.isBefore(dataComparacao)){

                var diaDaSemanaValido = false;
                switch(now.day())
                {
                    case 0:
                            diaDaSemanaValido = (arrExtracoes[i].bitDomingo == 1)
                        break;
                    case 1:
                            diaDaSemanaValido = (arrExtracoes[i].bitSegunda == 1)
                        break;
                    case 2:
                            diaDaSemanaValido = (arrExtracoes[i].bitTerca == 1)
                        break;
                    case 3:
                            diaDaSemanaValido = (arrExtracoes[i].bitQuarta == 1)
                        break;
                    case 4:
                            diaDaSemanaValido = (arrExtracoes[i].bitQuinta == 1)
                        break;
                    case 5:
                            diaDaSemanaValido = (arrExtracoes[i].bitSexta == 1)
                        break;
                    case 6:
                            diaDaSemanaValido = (arrExtracoes[i].bitSabado == 1)
                        break;
                }

                if(diaDaSemanaValido)
                    datas.push({ value: arrExtracoes[i].tnyExtracao, label: arrExtracoes[i].vchDescricao })            

            }
            


        }        
    }

    return datas
}

export function getExtracaoDescricao(arrExtracoes, tnyExtracao) {

    var vchDescricao = ''

    for (var i=0; i < arrExtracoes.length; i++) {
        if( arrExtracoes[i].tnyExtracao == tnyExtracao ){
            vchDescricao =  arrExtracoes[i].vchDescricao;
            break
        }
    }

    return vchDescricao
    

}


export function getExtracoesPredatada(arrExtracoes, dataRef){

    var moment = require('moment');
    var datas = [];
    var dataComparacao;
    
    var data = moment(dataRef ? dataRef: moment() );

    if(arrExtracoes == null)
        return datas;
        
    for (var i=0; i < arrExtracoes.length; i++) {

        if(arrExtracoes[i].bitBolao == 0 && arrExtracoes[i].bitConcurso == 0){

            dataComparacao = moment( data.format('DD-MM-YYYY ' + arrExtracoes[i].chrHorarioBloqueio), 'DD-MM-YYYY hh:mm');

            if(data.isBefore(dataComparacao)){
                
                var diaDaSemanaValido = false;
                if(arrExtracoes[i].bitHoje == 1)
                {
                    diaDaSemanaValido = true;
                }
                else
                {
                    switch(data.day())
                    {
                        case 0:
                                diaDaSemanaValido = (arrExtracoes[i].bitDomingo == 1)
                            break;
                        case 1:
                                diaDaSemanaValido = (arrExtracoes[i].bitSegunda == 1)
                            break;
                        case 2:
                                diaDaSemanaValido = (arrExtracoes[i].bitTerca == 1)
                            break;
                        case 3:
                                diaDaSemanaValido = (arrExtracoes[i].bitQuarta == 1)
                            break;
                        case 4:
                                diaDaSemanaValido = (arrExtracoes[i].bitQuinta == 1)
                            break;
                        case 5:
                                diaDaSemanaValido = (arrExtracoes[i].bitSexta == 1)
                            break;
                        case 6:
                                diaDaSemanaValido = (arrExtracoes[i].bitSabado == 1)
                            break;
                    }

                }                

                if(diaDaSemanaValido)
                    datas.push({ value: arrExtracoes[i].tnyExtracao, label: arrExtracoes[i].vchDescricao })            

            }
            


        }        
    }

    return datas
}


export function converteHorarioRodada(intHorarioRodada)
{
    let intParte = Math.floor(intHorarioRodada/60);
    let intResto = intHorarioRodada%60;
    return ("0" + intParte).slice(-2) + ":" + ("0" + intResto).slice(-2);
}




// WEBPACK FOOTER //
// ./src/loteria/utils/extracaoUtils.js